import { CrmAccountWithRole } from '@types-be/next-auth';

import { LS_KEY_ACCOUNTS } from './constants';
import { useAccountCookie } from './useAccountCookie';

export function useIsProspect() {
  const [accounts] = useAccountCookie<Array<CrmAccountWithRole>>(LS_KEY_ACCOUNTS);

  const isProspect = accounts && accounts.length === 0;

  return {
    accounts,
    isProspect,
  };
}
